
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8ymsB", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $k6V2N = parcelRequire("k6V2N");

var $jD5no = parcelRequire("jD5no");

var $2cigx = parcelRequire("2cigx");

var $jsLXn = parcelRequire("jsLXn");

var $9F6Ii = parcelRequire("9F6Ii");

var $9OXo1 = parcelRequire("9OXo1");
(0, $2cigx.provideHealthcheck)();
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4b6dc17684b8bd97$var$container = document.createElement('div');
$4b6dc17684b8bd97$var$container.id = 'heartbeat';
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild($4b6dc17684b8bd97$var$container);
(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { isAnonymous: isAnonymous } })=>!isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "heartbeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6V2N.default), null))))), $4b6dc17684b8bd97$var$container);

});
parcelRegister("k6V2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bdaf1985e1999a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1Re9 = parcelRequire("l1Re9");
const $5bdaf1985e1999a0$var$HeartbeatNew = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        const heartbeatService = (0, $l1Re9.getInstance)();
        return ()=>heartbeatService.cleanup();
    }, []);
    return null;
};
var $5bdaf1985e1999a0$export$2e2bcd8739ae039 = $5bdaf1985e1999a0$var$HeartbeatNew;

});

parcelRegister("2cigx", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c);
const $eec8e8449eafd9c1$var$globalObj = window || $parcel$global;
const $eec8e8449eafd9c1$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c = (healthcheck = $eec8e8449eafd9c1$var$defaultHealthcheck)=>{
    $eec8e8449eafd9c1$var$globalObj.performHealthcheck = healthcheck;
};

});



//# sourceMappingURL=async-heartbeat.7fd59a31.js.map
